import { Alert, Box, IconButton, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react';
import { GridTable } from '../Sidebar/SidebarStyles';
import { GetQcAccessList, UpdateQuoteCompareAccess } from '../ApiSevices/QuoteCompareAPI';
import { GridColDef } from '@mui/x-data-grid';
import CheckIcon from '@mui/icons-material/Check';
import { Cancel } from '@mui/icons-material';
import { green, red } from '@mui/material/colors';
import ConfirmationDialogComponent from '../Common/ConfirmationDialogComponent';

interface IState {
    loading: boolean;
    row: any[];
    snackbarOpen: boolean;
    snackbarMessage: any;
    snackbarSeverity: any;
    confirmationDialog: {
        isOpen: boolean,
        recordId: any,
        message: string,
        activate: boolean
    }
}

interface IProps {
    displaysidebar: boolean;
}

const columns: GridColDef[] = [
    { field: 'broker_id', headerName: 'Broker ID', width: 200 },
    { field: 'AppName', headerName: 'Application Name', width: 300 },
];

export default class QcConfig extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            row: [],
            confirmationDialog: {
                isOpen: false,
                recordId: 0,
                message: "",
                activate: false
            },
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'info',
        };
    }

    async componentDidMount(): Promise<void> {
        try {
            this.setState({ loading: true });
            await Promise.all([this.fetchConfigList()]);
        } catch (error) {
            console.error("error fetching data", error);
        }
        finally {
            this.setState({ loading: false })
        }
    }

    async fetchConfigList() {
        try {
            const response = await GetQcAccessList();
            if (response.status === 200) {
                this.setState({ row: response.data });
            }
        } catch (error) {
            console.error("error fetching config data:", error);
        }
    }

    async onConfirmationDialog() {
        try {
            this.setState({ loading: true });
            const { confirmationDialog } = this.state;
            const res = await UpdateQuoteCompareAccess(confirmationDialog.recordId.broker_id, !(confirmationDialog.recordId.AppName !== null && confirmationDialog.recordId.AppName.length > 0))
            if (res.status === 200) {
                this.showSnackbar("Updated Successfully", "success");
                this.setState({
                    confirmationDialog: {
                        isOpen: false,
                        message: "",
                        recordId: null,
                        activate: false
                    }
                });
                this.fetchConfigList();
            }
        } catch (error) {
            this.showSnackbar("Error updating Access", "error");
        } finally {
            this.setState({ loading: false });
        }
    }

    showSnackbar = (message: string, severity: "success" | "error" | "info" | "warning") => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    render() {
        const { loading, row, confirmationDialog, snackbarOpen, snackbarSeverity, snackbarMessage } = this.state;
        const { displaysidebar } = this.props;
        return (
            <>
                <div style={{ fontSize: "12px" }}>
                    {loading && (
                        <Box sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            zIndex: 9999
                        }}>
                            <div className="loader"></div> {/* Your loader component or custom CSS */}
                        </Box>
                    )}
                    <GridTable displaysidebar={displaysidebar}>
                        <p><b>Quote Compare Application Configuration</b></p><br />
                        <div style={{ paddingTop: "10px", paddingRight: "5px" }}>
                            <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #7a6e6e54' }}>
                                <Box sx={{ maxHeight: 450, overflowX: 'auto' }}>
                                    <TableContainer sx={{ minWidth: 'max-content' }}>
                                        <Table stickyHeader sx={{ height: '50px' }} size="small">
                                            {/* Table Header */}
                                            <TableHead>
                                                <TableRow>
                                                    {columns?.map((column) => (
                                                        <TableCell
                                                            key={column.field}
                                                            sx={{
                                                                fontSize: '12px',
                                                                fontWeight: 'bold',
                                                                whiteSpace: 'nowrap',
                                                                backgroundColor: '#f5f5f5',
                                                                position: 'sticky',
                                                                top: 0,
                                                                zIndex: 1,
                                                                textAlign: 'center',
                                                                width: column.width
                                                            }}
                                                        >
                                                            {column.headerName}
                                                        </TableCell>
                                                    ))}
                                                    <TableCell
                                                        sx={{
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            whiteSpace: 'nowrap',
                                                            backgroundColor: '#f5f5f5',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1,
                                                            textAlign: 'center',
                                                            width: '200px'
                                                        }}
                                                    >
                                                        Actions
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                        </Table>

                                        <Box sx={{ maxHeight: 400, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                                            <Table size="small">
                                                {/* Table Body */}
                                                <TableBody>
                                                    {row && Array?.isArray(row) && row?.length > 0 ? (
                                                        row?.map((row) => (
                                                            <TableRow key={row.Id}>
                                                                {columns?.map((column) => (
                                                                    <TableCell
                                                                        key={column.field}
                                                                        sx={{
                                                                            fontSize: '10px',
                                                                            whiteSpace: "normal !important",
                                                                            wordWrap: 'break-word',
                                                                            lineHeight: '1.5',
                                                                            textAlign: 'center',
                                                                            width: column.width,
                                                                        }}
                                                                    >
                                                                        {
                                                                            column.field === 'broker_id' && row[column.field]
                                                                        }
                                                                        {
                                                                            column.field === 'AppName' && row[column.field]
                                                                        }
                                                                    </TableCell>
                                                                ))}
                                                                <TableCell
                                                                    key={'action' + row.broker_id}
                                                                    sx={{
                                                                        fontSize: '10px',
                                                                        whiteSpace: "normal !important",
                                                                        wordWrap: 'break-word',
                                                                        lineHeight: '1.5',
                                                                        textAlign: 'center',
                                                                        width: 200,
                                                                    }}
                                                                >
                                                                    {
                                                                        row.AppName ?
                                                                            <Cancel fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                this.setState({
                                                                                    confirmationDialog: {
                                                                                        isOpen: true,
                                                                                        recordId: row,
                                                                                        message: `Are you Sure you want to remove access to this broker id: ${row.broker_id}?`,
                                                                                        activate: false
                                                                                    }
                                                                                });
                                                                            }} style={{ color: red[500] }} />
                                                                            :
                                                                            <CheckIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                this.setState({
                                                                                    confirmationDialog: {
                                                                                        isOpen: true,
                                                                                        recordId: row,
                                                                                        message: `Are you Sure you want to give access to this broker id: ${row.broker_id}?`,
                                                                                        activate: true
                                                                                    }
                                                                                });
                                                                            }} style={{ color: green[500] }} />
                                                                    }
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (<TableRow>
                                                        <TableCell colSpan={columns.length + 1} align="center" sx={{
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                            color: 'gray',
                                                            padding: '20px',
                                                            borderBottom: 'none',
                                                        }}>
                                                            No records to display
                                                        </TableCell>
                                                    </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    </TableContainer>
                                </Box>

                                <ConfirmationDialogComponent open={confirmationDialog.isOpen} message={confirmationDialog.message} onConfirm={() => { this.onConfirmationDialog() }} onClose={() => {
                                    this.setState({
                                        confirmationDialog: {
                                            isOpen: false,
                                            recordId: 0,
                                            message: "",
                                            activate: false,
                                        }
                                    });
                                }} />
                            </Paper>
                            <Snackbar
                                open={snackbarOpen}
                                autoHideDuration={2500}
                                onClose={() => this.setState({ snackbarOpen: false })}
                                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                            >
                                <Alert onClose={() => this.setState({ snackbarOpen: false })} severity={snackbarSeverity} sx={{ width: "100%" }}>
                                    {snackbarMessage}
                                </Alert>
                            </Snackbar>
                        </div>
                    </GridTable>
                </div>
            </>
        )
    }
}
